export default "__VITE_ASSET__4I6XYWu$__"